export default (state, primaryKey, secondaryKey) => {
    const serverData = state.getIn(['wpServerData', primaryKey])
    const localData = state.getIn(['wpLocalData', primaryKey])

    const serverdataSecondaryKeyData = serverData.getIn([secondaryKey])
    const localdataSecondaryKeyData = localData.getIn([secondaryKey])
    
    if(!localdataSecondaryKeyData) {
       return serverdataSecondaryKeyData
    } else {
       return serverdataSecondaryKeyData.mergeDeep(localdataSecondaryKeyData)
                                       .filter((k) => {
                                          if(localData.has('deletedItems')) {
                                             return !localData.getIn(['deletedItems']).has(k)
                                          } else {
                                             return true
                                          }
                                       });
    }



}